<!-- 询价单列表 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="addNew(3)" v-if="permission.addOrder">{{ permission.addOrder }} (F1)</el-button>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
                <el-button v-if="permission.add" size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="add(3)">{{ permission.add }} (F3)</el-button>
                <el-button v-if="permission.print" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{ permission.print }}</el-button>
                <el-button v-if="permission.export" size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportForm()">{{ permission.export }}</el-button>
                <el-button v-if="permission.importCreateOrder" size="small" class="search-btn btn-primary" @click="gotoImportCreatePage"
                    ><i class="fa fa-file-excel-o"></i> {{ permission.importCreateOrder }}</el-button
                >
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="history()" v-if="permission.history">{{ permission.history }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="permission.searchAP">{{ permission.searchAP }}</el-button>
                <el-button size="small" type="warning" class="search-btn" @click="gotoIntenTranOrder()" v-if="permission.intenTranPur">{{ permission.intenTranPur }}</el-button>
                <el-button size="small" type="warning" class="search-btn" @click="gotoIntenTranOrderNew()" v-if="permission.intenTranPurN">{{
                    permission.intenTranPurN
                }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="gotoOrderGoodsMannger()" v-if="permission.orderGoodsMannger">
                    {{ permission.orderGoodsMannger }}
                </el-button>
            </div>
        </div>
        <div class="table-ctn inquiry-order-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                border
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                v-loading="loading"
                :summary-method="getSummaries"
                show-summary
                :tableCode="tableCode"
                @sort-change="sortChange"
                :row-key="getRowKeys"
            >
                <el-table-column type="selection" width="50"></el-table-column>
                <template v-for="(col,index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'InquiryCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                                {{ scope.row.InquiryCode }}
                            </el-badge>
                            {{ scope.row.PrintedCount > 0 ? '' : scope.row.InquiryCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort?'custom':false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.edit && scope.row.IsCanUpdate && !scope.row.IsTranInten" title="编辑" size="mini" type="text" @click="add(2, scope.row)">{{
                                permission.edit
                            }}</el-button>
                            <el-button
                                v-if="permission.editOrder && scope.row.IsCanUpdate && !scope.row.IsTranInten"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="addNew(2, scope.row)"
                                >{{ permission.editOrder }}</el-button
                            >
                            <el-button v-if="permission.trans && scope.row.IsCanTransform" title="转为采购订单" size="mini" type="text" @click="gotoSalesOrderEdit(scope.row)">{{
                                permission.trans
                            }}</el-button>
                            <el-button
                                v-if="permission.transN && scope.row.IsCanTransform"
                                title="转为采购订单"
                                size="mini"
                                type="text"
                                @click="gotoSalesOrderEditNew(scope.row)"
                                >{{ permission.transN }}</el-button
                            >
                            <el-button
                                v-if="permission.addToInten && scope.row.IsCanTransform && !scope.row.IsTranInten"
                                title="并入在订"
                                style="color: orange"
                                size="mini"
                                type="text"
                                @click="addToInten(scope.row)"
                                >{{ permission.addToInten }}</el-button
                            >
                            <el-button v-else-if="scope.row.IsTranInten" title="已并入在订" size="mini" type="text" disabled>已并入在订</el-button>
                            <el-button v-if="(permission.del && scope.row.IsCanDel) || (permission.del && !scope.row.IsTranInten)" title="删除" size="mini" type="text" style="color: red" @click="del(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="870px">
            <div class="dialog-content" v-if="dialogVisible">
                <printsupplierRFQ @closeDialog="closeDialog" :printIds="idList"></printsupplierRFQ>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP canEdit="canNot" @closeDialog="closeSearchDialog"></searchAP>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="询价单据搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-inquiry-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="供应商">
                        <el-select
                            ref="search_sup"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Keyword"
                            remote
                            filterable
                            allow-create
                            placeholder="请输入供应商名称"
                            :remote-method="searchSupplier"
                            v-select-scroll-more="searchSupplierLoad"
                        >
                            <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="询价单号">
                        <el-input size="small" v-model.trim="searchData.InquiryCode" v-filter-special-char="searchData.InquiryCode" placeholder="询价单号"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态" v-if="isExObj('StateName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="询价日期" v-if="isExObj('ITime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="报价日期" v-if="isExObj('QTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime3"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate3TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import mixin from '@/mixins/mixin';
import searchAP from '@/components/common/searchAP';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        searchAP,
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            tableCode: 'XJOrderTable',
            isStopReq: false,
            loading: false,
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '已询价', Value: '1' },
                { Text: '已转为订单', Value: '2' }
            ],
            idList: [],
            searchVisible: false,
            dialogVisible: false,
            searchData: {
                Keyword: '',
                State: '',
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                InquiryCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                QStartDate: '',
                QEndDate: '',
                IStartDate: '',
                IEndDate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isStartSearch: false,
            datetime: [],
            datetime1: [],
            datetime2: [],
            datetime3: [],
            dialogSearchVisible: false,
            columnShowSets: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_sup.focus();
                });
            }
        }
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            // this.getTableData();
            this.getConfigByCodes();
        }
        //切换页面的时候不会清除当前页面缓存，但是其他页面也有相同字段，会串页面数据，还是把数据清空了不要误导
        this.$refs.multipleTable.clearSelection();
        this.idList = [];
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();
        this.getConfigByCodes();
    },
    mounted() {
        let that = this;
        that.permission = that.$util.getPermission('supplierRFQ');
        Vue.component('printsupplierRFQ', function (resolve) {
            that.$util.getPrintComponents('6').then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printPurInquiry'], resolve);
                }
            });
        });
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //F1
            if (key === 112) {
                e.preventDefault();
                that.addNew(3);
            }
            //F2
            if (key === 113) {
                e.preventDefault();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.add(3);
            }
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                }
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        getConfigByCodes() {
            let that = this;
            let codes = ['djmrdtsj'];
            let isDefaultToday = false;
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'djmrdtsj':
                                isDefaultToday = result;
                                break;
                        }
                    }
                    if (isDefaultToday) {
                        //当前设定的日期时间
                        let d = new Date();
                        let year1, month1, day1;
                        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date1 = new Date(year1, month1, day1, 0);
                        that.datetime.push(date1);

                        //前一天设定的日期时间
                        let year2, month2, day2;
                        d.setTime(d.getTime());
                        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date2 = new Date(year2, month2, day2, 0);
                        that.datetime.unshift(date2);

                        that.searchData.IStartDate = date2;
                        that.searchData.IEndDate = date1;
                    }
                }
                that.getTableData();
            });
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        showSearch() {
            this.searchVisible = true;
        },
        closeSearchDialog() {
            this.searchVisible = false;
        },
        // 导出
        exportForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let InquiryIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpInquiryOrder/ExportEntpInqOrder',
                data: {
                    InquiryIds: InquiryIds,
                    EntpId: this.searchData.EntpId
                }
            });
        },
        gotoSalesOrderEdit(item) {
            let id = item ? item.InquiryId : '';
            this.$router.push(`/purchaseManage/inquirySheet/transToPurchaseOrders?type=4&id=${id}&fromLv2=buyManage`);
        },
        gotoSalesOrderEditNew(item) {
            let id = item ? item.InquiryId : '';
            this.$router.push(`/purchaseManage/inquirySheet/transToPurchaseOrders_V3?type=4&id=${id}`);
        },
        gotoIntenTranOrder() {
            this.$router.push(`/purchaseManage/inquirySheet/transToPurchaseOrders?type=8`);
        },
        gotoIntenTranOrderNew() {
            this.$router.push(`/purchaseManage/inquirySheet/transToPurchaseOrders_V3?type=8`);
        },
        gotoOrderGoodsMannger() {
            this.$router.push(`/purchaseManage/inquirySheet/orderGoodsMannger`);
        },
        handleSelectionChange(val) {
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].InquiryId);
            }
            this.idList = idList;
        },
        closeDialog(isPrint) {
            this.dialogVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.InquiryId == this.idList[0]) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        print() {
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张询价单打印');
                return;
            }
            this.dialogVisible = true;
        },
        add(type, item) {
            let id = item ? item.InquiryId : '';
            this.$router.push(`/purchaseManage/inquirySheet/edit_v2?type=${type}&id=${id}&fromLv2=buyManage`);
        },
        addNew(type, item) {
            let id = item ? item.InquiryId : '';
            this.$router.push(`/purchaseManage/inquirySheet/edit_v3?type=${type}&id=${id}`);
        },
        // 跳转历史配件询价
        history() {
            this.$router.push(`/purchaseManage/inquirySheet/histories`);
        },
        gotoImportCreatePage() {
            this.$router.push('/purchaseManage/inquirySheet/importToCreateOrder');
        },
        resetSearch() {
            this.searchData = {
                Keyword: '',
                State: '',
                EntpId: this.searchData.EntpId,
                InquiryCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                QStartDate: '',
                QEndDate: '',
                IStartDate: '',
                IEndDate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime = [];
            this.datetime1 = [];
            this.datetime2 = [];
            this.datetime3 = [];
            // this.searchSupplier('');
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpInquiryOrder/GetEntpSupInquiryOrderList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.add(1, event);
            }
        },
        addToInten(item) {
            let that = this;
            if (item.InquiryId) {
                that.$confirm('您确定要将【' + item.InquiryCode + '】并入在订吗？一旦并入，仅转采购才能减少在订数', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '我再考虑考虑',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpInquiryOrder/AddToIntenDatas?InquiryId=` + item.InquiryId
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                that.handleSearch();
                                // let sIdx = that.tableData.findIndex(f => f.InquiryId === item.InquiryId);
                                // if (sIdx > -1) {
                                //     that.tableData[sIdx].IsTranInten = true;
                                // }
                            })
                            .finally(() => {});
                    })
                    .catch(() => {});
            }
        },
        del(item) {
            let that = this;
            if (item.InquiryId) {
                that.$confirm('您确定要将【' + item.InquiryCode + '】删除吗？一旦删除，数据将无法恢复', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '我再考虑考虑',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpInquiryOrder/DelEntpInquiryOrder?InquiryId=` + item.InquiryId
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                that.getTableData();
                            })
                            .finally(() => {});
                    })
                    .catch(() => {});
            }
        },
        showSearchDialog() {
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.IStartDate = val[0];
                this.searchData.IEndDate = val[1];
            } else {
                this.searchData.IStartDate = '';
                this.searchData.IEndDate = '';
            }
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.QStartDate = val[0];
                this.searchData.QEndDate = val[1];
            } else {
                this.searchData.QStartDate = '';
                this.searchData.QEndDate = '';
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.InquiryId;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (
                    column.property == 'NeedTime' ||
                    column.property == 'InquiryCode' ||
                    column.property == 'Creator' ||
                    column.property == 'CallNum' ||
                    column.property == 'Remark' ||
                    column.property == 'UpdateTime' ||
                    column.property == 'CreateTime'
                ) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        }
    }
};
</script>
<style lang="less" scoped>
#search-inquiry-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.inquiry-order-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
